// extracted by mini-css-extract-plugin
module.exports = {"tabLabels":"PlainTabs_tabLabels__iwm6H","tabLabelItem":"PlainTabs_tabLabelItem__3jtrN","tabLabelItemActive":"PlainTabs_tabLabelItemActive__-MEwa"};